module.exports = __webpack_public_path__ + "static/media/iland.6e7cf50e.svg";